import { Repository, EntityRepository } from 'typeorm';
import { IndentMaterialEntity } from '../indent-form-entity';


@EntityRepository(IndentMaterialEntity)
export class IndentMaterialFormRepository extends Repository<IndentMaterialEntity>{

    
    
}
